<template>
  <div :class="mainClass" @click="$emit('on-selected', true)">
    <i v-if="selected" :style="`color:${selectedColor}!important`" :class="checkedClass" />
    <i v-if="!selected" :style="`color:${notSelectedColor} !important;`" :class="unCheckedClass" />
    <span v-if="!selected" :style="`color:${notSelectedColor}!important`" :class="checkedClassText">{{ label }}</span>
    <span v-if="selected" :style="`color:${selectedColor}!important`" :class="unCheckedClassText">{{ label }}</span>
    <InfoTooltipBase
      v-if="tooltipId && tooltipMessage"
      :id="`category-tooltip-${tooltipId}`"
      :class="tooltipClass"
      :text="tooltipMessage"
      :placement="tooltipPlacement"
    />
  </div>
</template>
<script>
import InfoTooltipBase from "@/components/common/InfoTooltipBase.vue";

export default {
  components: {
    InfoTooltipBase,
  },
  props: {
    mainClass: { type: String, default: "d-flex align-items-center w-100" },
    selected: { type: Boolean, default: false },
    label: { type: String },
    tooltipClass: { type: String, default: "ml-2" },
    tooltipId: { type: String },
    tooltipPlacement: { type: String, default: "bottom" },
    tooltipMessage: { type: String },
    selectedColor: { type: String, default: "#84a263" },
    notSelectedColor: { type: String, default: "#49545a" },
    checkedClass: { type: String, default: "fas fa-check-square clickable" },
    unCheckedClass: { type: String, default: "far fa-square clickable" },
    checkedClassText: { type: String, default: "clickable" },
    unCheckedClassText: { type: String, default: "clickable" },
  },
  emits: ["on-selected"],
};
</script>
